<template>
  <!-- <v-expansion-panel
    v-model="panel"
    expand
    @click.native="paymentOption = 'CC'"
    :class="
      paymentOption === interests.id ? 'option-active' : 'option-deactive'
    "
  >
    <v-expansion-panel-content> -->
  <v-radio-group v-model="paymentOption" @click="clickRadio" :mandatory="false">
    <div
      style="min-height: 77px;"
      class="radio-option-custom pt-0"
      @click="paymentOption = option.id"
      :class="paymentOption == option.id ? 'option-active' : 'option-deactive'"
    >
      <v-layout class="radio-option__info">
        <v-flex>
          <v-layout row>
            <v-icon class="payment-option_icon">credit_card</v-icon>
            <div class="radio-option__info-text">
              <label :for="option.id">{{ option.label }}</label>
              <h4
                v-if="
                  interests.parcelas &&
                    userProps.selectedDocument !== 'foreigner'
                "
                class="checkout-h4 grey--text"
              >
                Pague em até {{ interests.parcelas.length }}x
              </h4>
            </div>
          </v-layout>
        </v-flex>
        <v-flex shrink>
          <v-radio
            style="margin-right: 6px;"
            color="primary"
            :id="option.id"
            :value="option.id"
          ></v-radio>
        </v-flex>
      </v-layout>

      <!-- <div>
        <div class="payment-option">
          <v-icon class="payment-option_icon">credit_card</v-icon>
          <div>
            <h3 class="checkout-h3">Cartão de crédito</h3>
            <h4
              v-if="interests.parcelas"
              class="checkout-h4 grey--text"
            >Pague em até {{ interests.parcelas.length }}x</h4>
          </div>
        </div>
      </div> -->
      <v-card flat v-if="paymentOption === 'CC' && $route.name !== 'totem'">
        <v-container align-center>
          <div>
            <div v-if="userProps.selectedDocument !== 'foreigner'">
              <h3 class="checkout-h3">
                <strong>Em quantas parcelas?</strong>
              </h3>
              <dropdown
                style="width: 100%;"
                :options="optionsParcelas"
                :selected="loads"
                v-on:updateOption="updateLoads"
              ></dropdown>
            </div>
            <!-- <v-select
            outline
            required
            :rules="rules"
            :items="interests.parcelas"
            v-model="loads"
            label="Selecione"
          ></v-select>-->
            <h3 class="checkout-h3">
              <strong>Dados do cartão:</strong>
            </h3>
            <v-text-field
              class="custom-text"
              outline
              required
              :rules="cardNumberRule"
              label="Número do cartão"
              autocomplete="cc-number"
              v-model="cardNumber"
              append-icon="lock"
              mask="####-####-####-####"
            ></v-text-field>
            <v-layout d-flex justify-space-between>
              <v-flex xs6>
                <v-text-field
                  class="custom-text"
                  outline
                  required
                  :rules="rules"
                  label="Vencimento"
                  autocomplete="cc-exp"
                  v-model="cardDate"
                  append-icon="todays"
                  mask="##/##"
                ></v-text-field>
              </v-flex>
              <v-flex xs5>
                <v-tooltip top>
                  <v-text-field
                    class="custom-text"
                    outline
                    required
                    :rules="cvcRules"
                    label="CVC"
                    autocomplete="cc-csc"
                    v-model="cardCVC"
                    append-icon="help"
                    mask="####"
                    slot="activator"
                  ></v-text-field>
                  <span class="white--text">Código de segurança</span>
                </v-tooltip>
              </v-flex>
            </v-layout>
            <v-text-field
              class="custom-text"
              outline
              required
              :rules="cardNameRule"
              label="Nome e sobrenome do titular"
              autocomplete="cc-name"
              v-model="cardName"
              append-icon="person"
            ></v-text-field>
          </div>
          <!-- <div class="bt-input">
            <v-text-field
              class="custom-text"
              outline
              required
              :rules="cpfRule"
              label="CPF do titular do cartão"
              mask="###.###.###-##"
              v-model="cardCPF"
            ></v-text-field>
            <svg class="input-svg" style="width:24px;height:24px" viewBox="0 0 24 24">
              <path
                fill="#777"
                d="M2,3H22C23.05,3 24,3.95 24,5V19C24,20.05 23.05,21 22,21H2C0.95,21 0,20.05 0,19V5C0,3.95 0.95,3 2,3M14,6V7H22V6H14M14,8V9H21.5L22,9V8H14M14,10V11H21V10H14M8,13.91C6,13.91 2,15 2,17V18H14V17C14,15 10,13.91 8,13.91M8,6A3,3 0 0,0 5,9A3,3 0 0,0 8,12A3,3 0 0,0 11,9A3,3 0 0,0 8,6Z"
              />
            </svg>
          </div> -->
        </v-container>
      </v-card>
      <!-- </v-expansion-panel-content>
  </v-expansion-panel> -->
    </div>
  </v-radio-group>
</template>

<script>
import dropdown from 'vue-dropdowns';
import { mapGetters } from 'vuex';

export default {
  components: { dropdown },
  data() {
    return {
      option: {
        id: 'CC',
        label: 'Cartão de Crédito',
        info: '',
      },
      loads: null,
      specialCode: null,
      firstClick: false,
      rules: [v => !!v || 'Campo obrigatório'],
      cpfRule: [
        v => !!v || 'Campo obrigatório',
        cpf => {
          let numeros;
          let digitos;
          let soma;
          let i;
          let resultado;
          let digitosIguais;
          digitosIguais = 1;
          if (cpf.length < 11) {
            return 'CPF inválido';
          }
          for (i = 0; i < cpf.length - 1; i++) {
            if (cpf.charAt(i) !== cpf.charAt(i + 1)) {
              digitosIguais = 0;
              break;
            }
          }
          if (!digitosIguais) {
            numeros = cpf.substring(0, 9);
            digitos = cpf.substring(9);
            soma = 0;
            for (i = 10; i > 1; i--) {
              soma += numeros.charAt(10 - i) * i;
            }
            resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
            if (resultado !== parseInt(digitos.charAt(0))) {
              return 'CPF inválido';
            }
            numeros = cpf.substring(0, 10);
            soma = 0;
            for (i = 11; i > 1; i--) {
              soma += numeros.charAt(11 - i) * i;
            }
            resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
            if (resultado !== parseInt(digitos.charAt(1))) {
              return 'CPF inválido';
            }
            return true;
          }
          return 'CPF inválido';
        },
      ],
      cardNameRule: [
        v => !!v || 'Campo obrigatório',
        v => /^[a-zA-Z\u00C0-\u024F\s]+$/.test(v) || 'Somente letras',
      ],
      cardNumberRule: [
        v => !!v || 'Campo obrigatório',
        v => {
          const visa = /^4[0-9]{12}(?:[0-9]{3})?$/;
          const master = /^(?:5[1-5][0-9]{2}|222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}$/;
          const amex = /^3[47][0-9]{13}$/;
          const dinners = /^3(?:0[0-5]|[68][0-9])[0-9]{11}$/;
          const discover = /^6(?:011|5[0-9]{2})[0-9]{12}$/;
          const jcb = /^(?:2131|1800|35\d{3})\d{11}$/;
          const elo = /^((((636368)|(438935)|(504175)|(451416)|(636297))\d{0,10})|((5067)|(4576)|(4011))\d{0,12})$/;
          const hipercard = /^(606282\d{10}(\d{3})?)|(3841\d{15})$/;
          const maestro = /^(?:5[0678]\d\d|6304|6390|67\d\d)\d{8,15}$/;

          if (visa.test(v)) {
            return true;
          }
          if (master.test(v)) {
            return true;
          }
          if (amex.test(v)) {
            return true;
          }
          if (dinners.test(v)) {
            return true;
          }
          if (discover.test(v)) {
            return true;
          }
          if (jcb.test(v)) {
            return true;
          }
          if (elo.test(v)) {
            return true;
          }
          if (hipercard.test(v)) {
            return true;
          }
          if (maestro.test(v)) {
            return true;
          }
          return 'Cartão inválido';
        },
      ],
      cvcRules: [
        v => !!v || 'Campo obrigatório',
        v => /(\d{3,4})/.test(v) || 'Código inválido',
      ],
    };
  },
  methods: {
    clickRadio() {
      if (this.isSpecialCupom && !this.firstClick) {
        this.firstClick = true;
        this.specialCode = localStorage.getItem(`cupomCode`);
        this.cardNumber = this.specialCode;
      }
    },
    updateLoads(data) {
      data = data.value;
      this.body = {
        ...this.body,
        parcelas: data.instalments,
      };
      this.$store.dispatch('setInstalmentAmount', data.instalments);
      this.$store.dispatch('setInterestAmount', data.interestAmount);
      this.$store.dispatch('setTotalAmount', data.total);
    },
  },
  computed: {
    ...mapGetters({
      userProps: 'userProps',
      buyerData: 'buyerData',
    }),
    interests() {
      const data = this.$store.getters.interests;
      return data;
    },
    cupomCode() {
      return this.$store.getters.cupomCode;
    },
    isSpecialCupom() {
      return this.$store.getters.isSpecialCupom;
    },
    optionsParcelas() {
      let p = this.interests.parcelas.map(e => ({ ...e, name: e.text }));
      return p;
    },
    body: {
      get() {
        return this.$store.getters.body;
      },
      set(value) {
        this.$store.dispatch('setBody', value);
      },
    },
    paymentOption: {
      get() {
        return this.$store.getters.paymentOption;
      },
      set(value) {
        this.$store.dispatch('setPaymentOption', value);
      },
    },
    panel: {
      get() {
        return [this.paymentOption === this.interests.id];
      },
      set(value) {},
    },
    cardName: {
      get() {
        return this.$store.getters.cardName;
      },
      set(value) {
        this.$store.dispatch('setCardName', value);
      },
    },
    cardCPF: {
      get() {
        return this.$store.getters.cardCPF;
      },
      set(value) {
        this.$store.dispatch('setCardCPF', value);
      },
    },
    cardNumber: {
      get() {
        return this.$store.getters.cardNumber;
      },
      set(value) {
        this.$store.dispatch('setCardNumber', value);
      },
    },
    cardDate: {
      get() {
        return this.$store.getters.cardDate;
      },
      set(value) {
        this.$store.dispatch('setCardDate', value);
      },
    },
    cardCVC: {
      get() {
        return this.$store.getters.cardCVC;
      },
      set(value) {
        this.$store.dispatch('setCardCVC', value);
      },
    },
  },
  mounted() {
    if (this.isSpecialCupom) {
      this.specialCode = localStorage.getItem(`cupomCode`);
      this.cardNumber = this.specialCode;
    }
  },
  created() {
    if (this.interests) {
      const data = this.interests;
      this.loads = { ...data.parcelas[0], name: data.parcelas[0].text };
      this.updateLoads(data.parcelas[0]);
    }
  },
  watch: {
    cardNumber() {
      if (this.specialCode && this.cardNumber.length < 6) {
        this.cardNumber = '';
        setTimeout(() => {
          this.cardNumber = this.specialCode;
        }, 200);
      }
    },
    paymentOption() {
      if (
        this.paymentOption === 'CC' &&
        this.userProps.name &&
        this.userProps.document
      ) {
        this.cardName = this.userProps.name;
        this.cardCPF = this.userProps.document;
      }

      if (this.interests) {
        const data = this.interests;
        this.loads = { ...data.parcelas[0], name: data.parcelas[0].text };
        this.updateLoads(data.parcelas[0]);
      }
    },
    interests() {
      const data = this.interests;
      this.loads = { ...data.parcelas[0], name: data.parcelas[0].text };
      this.updateLoads(data.parcelas[0]);
    },
    'userProps.selectedDocument'() {
      if (this.userProps.selectedDocument === 'foreigner') {
        const data = this.interests;
        this.loads = { ...data.parcelas[0], name: data.parcelas[0].text };
        this.updateLoads(data.parcelas[0]);
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/payment/paymentCard.styl'
@import '~@/assets/payment/paymentBillet.styl'
</style>

<style>
.custom-text .v-label {
  top: 18px !important;
}
</style>
